import { styled } from '@mui/material';
import React, { useMemo } from 'react';
import moment from 'moment';
import { TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING } from '../../utils/constants/Constants.js';
import { GenericContainer } from '../components/GenericContainer.js';

var _a;
var HeaderContainer = styled(GenericContainer)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'left',
            paddingTop: 29.5,
            paddingBottom: 10,
            boxSizing: 'border-box',
            color: theme.palette.primary.main
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(TABLET_HORIZONTAL_PADDING, "px"),
        },
        _b["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(MOBILE_HORIZONTAL_PADDING, "px"),
        },
        _b);
});
var Title = styled('div')((_a = {
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        fontSize: 50,
        fontWeight: 'bold',
        lineHeight: 1.1,
        textAlign: 'left'
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        fontSize: 50,
        padding: '0 0px',
    },
    _a));
var Timestamp = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        textAlign: 'left',
        fontSize: 18,
        fontWeight: 500,
        lineHeight: '25px',
        opacity: 0.6,
        color: theme.palette.primary.main,
    });
});
var EditorialHeader = function (_a) {
    var page = _a.page;
    var createdTime = (page === null || page === void 0 ? void 0 : page.createdTime) || 1669793485504;
    var dateString = useMemo(function () {
        if (!createdTime) {
            return '';
        }
        var timeInSeconds = createdTime.toString().length > 10 ? createdTime / 1000 : createdTime;
        return moment.unix(timeInSeconds).format('MMM D, YYYY');
    }, [page === null || page === void 0 ? void 0 : page.createdTime]);
    return (React.createElement(HeaderContainer, null,
        React.createElement(Title, null, page === null || page === void 0 ? void 0 : page.displayName),
        createdTime ? React.createElement(Timestamp, null, dateString) : null));
};

export { EditorialHeader };
//# sourceMappingURL=index.js.map
